import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";

export default class MultipleProduct extends ClientProductWithHierarchy {
  static type = "clientsMultipleProduct";

  matched!: boolean;
}
